var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',{attrs:{"placeholder":_vm.placeholder,"clearable":false,"value":_vm.model,"align":"right","type":_vm.type},on:{"input":_vm.handleInputEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }